import { render } from "./CardUserProfile.vue?vue&type=template&id=251736b6&scoped=true&lang=pug"
import script from "./CardUserProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./CardUserProfile.vue?vue&type=script&setup=true&lang=js"

import "./CardUserProfile.vue?vue&type=style&index=0&id=251736b6&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251736b6"]])

export default __exports__